// ============================================
// CHAPTER FORM MODAL - PROCESSING MODAL
// Formulário para cadastrar conteúdo tipo "capitulo"
// ============================================
import React, { Component, Fragment } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '../../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import EditIcon from '@material-ui/icons/Edit'
import { ContentHtml } from 'informed-shared/components/es/Content'

import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction, getApiErrorMessage } from '../../../utils'
import * as API from '../../../api'
import { connect } from 'react-redux'
import { bookVectorizationActions, messageActions } from '../../../actions'

import { CodigoCapituloField } from '../../../components/Fields'

import { processHtmlWithTableBorders } from '../../../utils/htmlUtils'
import { prepareImagesForCms } from '../../../utils/cmsHtmlImages'
import LocalHtmlEditorModal from '../../../components/LocalHtmlEditorModal'

// ============================================
// ESTILOS
// ============================================
const styles = () => ({
  formControl: {
    margin: '12px 0',
  },
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogContent: {
    position: 'relative',
    minHeight: '300px',
  },
  htmlPreview: {
    border: '1px solid #e0e0e0',
    borderRadius: '2px',
    padding: '16px',
    maxHeight: '300px',
    minHeight: '180px',
    overflow: 'auto',
    backgroundColor: '#fff',
    marginTop: '8px',
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      margin: '8px 0',
    },
    '& td, & th': {
      border: '1px solid #ccc',
      padding: '4px 8px',
      verticalAlign: 'top',
    },
    '& th, & .gravata, & [class*="gravata"], & .thead, & .table-header': {
      backgroundColor: '#e8eaf6 !important',
      fontWeight: 'bold',
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
  htmlPreviewLabel: {
    marginTop: '16px',
    marginBottom: '4px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  existingWarning: {
    padding: '12px',
    marginBottom: '16px',
    border: '1px solid #ffb74d',
    borderRadius: '4px',
    backgroundColor: '#fff3e0',
  },
  statusLoading: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    '& > * + *': {
      marginLeft: 8,
    },
  },
  sectionAboutControl: {
    marginTop: 20,
    marginBottom: 0,
  },
  sectionAboutTextarea: {
    maxHeight: 120,
    overflowY: 'auto',
    resize: 'none',
  },
})

const getFirstValue = (...values) => {
  for (let value of values) {
    if (Array.isArray(value) && value.length) return value
    if (value !== undefined && value !== null && value !== '') return value
  }

  return Array.isArray(values[values.length - 1]) ? [] : ''
}

// ============================================
// COMPONENTE PRINCIPAL
// ============================================
class ChapterFormModal extends Component {
  constructor(props) {
    super(props)

    const { chapter, bookIsbn, bookName, cms = {}, existingContent, chapterDefaults = {} } = props
    const rawHtml = (chapter || {}).conteudoHtml || (chapter || {}).conteudo || ''

    const processedHtml = processHtmlWithTableBorders(rawHtml)

    this.state = {
      saving: false,
      editorOpen: false,
      htmlPreview: processedHtml,
      htmlPreviewError: null,
      htmlPreviewValid: false,
      previewingHtml: false,
      content: {
        tipo: 'capitulo',
        titulo: (chapter || {}).titulo || (chapter || {}).capitulo || '',
        isbn: bookIsbn || '',
        tituloLivro: bookName || '',
        conteudoHtml: processedHtml,
        idVetor: ((chapter || {}).idVetor || (chapter || {}).id_vetor || '').toString(),
        autores: getFirstValue((chapter || {}).autores, chapterDefaults.autores, cms.autoresLivro, []),
        editores: [],
        especialidades: getFirstValue(
          (chapter || {}).especialidades,
          chapterDefaults.especialidades,
          cms.especialidadesLivro,
          [],
        ),
        pesoDA: getFirstValue((chapter || {}).pesoDA, chapterDefaults.pesoDA, ''),
        idioma: getFirstValue((chapter || {}).idioma, chapterDefaults.idioma, ''),
        palavrasChave: getFirstValue((chapter || {}).palavrasChave, chapterDefaults.palavrasChave, []),
        codigo: (existingContent || {}).codigo || (chapter || {}).codigo || '',
        codigoProtheus: cms.codigoProtheus || '',
        autoresLivro: cms.autoresLivro || [],
        copyrightLivro: cms.copyrightLivro || '',
        edicaoLivro: cms.edicaoLivro || '',
        especialidadesLivro: cms.especialidadesLivro || [],
        tituloSecao: (chapter || {}).tituloSecao || '',
        autoresSecao: getFirstValue((chapter || {}).autoresSecao, chapterDefaults.autoresSecao, []),
        textoSecao: (chapter || {}).textoSecao || '',
        livroReferencia: cms.livroReferencia || '',
        document: '',
        buscaPalavrasChave: [],
        buscaPeso: '',
      },
    }
  }

  getRepeatedContentFields = () => {
    const { content } = this.state

    return {
      autores: content.autores || [],
      especialidades: content.especialidades || [],
      palavrasChave: content.palavrasChave || [],
      pesoDA: content.pesoDA || '',
      idioma: content.idioma || '',
      autoresSecao: content.autoresSecao || [],
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.refreshHtmlPreview(this.state.content.conteudoHtml)
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleChangeField = (field, value) => {
    this.setState((prevState) => ({
      content: { ...prevState.content, [field]: value },
    }))
  }

  handleOpenEditor = () => {
    this.setState({ editorOpen: true })
  }

  handleCloseEditor = () => {
    this.setState({ editorOpen: false })
  }

  handleApplyHtml = (newHtml) => {
    this.setState(
      (prevState) => ({
        content: { ...prevState.content, conteudoHtml: newHtml },
        editorOpen: false,
      }),
      () => this.refreshHtmlPreview(newHtml),
    )
  }

  refreshHtmlPreview = (html) => {
    const { changeMessage, chapterIndex } = this.props

    if (!html) {
      this.setState({
        htmlPreview: '',
        htmlPreviewError: 'O capítulo não possui conteúdo HTML.',
        htmlPreviewValid: false,
        previewingHtml: false,
      })
      return Promise.resolve()
    }

    const data = new FormData()
    const document = new Blob([prepareImagesForCms(html)], { type: 'text/html' })
    data.append(
      'document',
      document,
      'capitulo-' + ((chapterIndex || 0) + 1) + '-preview.html',
    )

    this.setState({
      htmlPreview: html,
      htmlPreviewError: null,
      htmlPreviewValid: false,
      previewingHtml: true,
    })

    return API.content
      .getHtmlPreview(data)
      .then((response) => {
        if (!this._isMounted) return

        const previewData = ((response || {}).data || {})
        const htmlPreview = previewData.htmlPreview || html

        this.setState((prevState) => ({
          content: {
            ...prevState.content,
            conteudoHtml: previewData.isValid === false ? html : htmlPreview,
          },
          htmlPreview,
          htmlPreviewError: null,
          htmlPreviewValid: true,
          previewingHtml: false,
        }))
      })
      .catch((err) => {
        if (!this._isMounted) return

        const htmlPreviewError = getApiErrorMessage(
          err,
          'O HTML não foi aceito pela estrutura do CMS.',
        )

        this.setState({
          htmlPreviewError,
          htmlPreviewValid: false,
          previewingHtml: false,
        })
        changeMessage({ message: htmlPreviewError, type: 'error' })
      })
  }

  handleSave = () => {
    const {
      chapter,
      chapterIndex,
      bookName,
      changeMessage,
      existingContent,
      onConflict,
      onClose,
      onSaved,
      saveBookChapterInCms,
    } = this.props
    const { content, htmlPreviewValid, previewingHtml } = this.state

    if (!content.titulo || !content.isbn || !content.idVetor || !content.conteudoHtml) {
      changeMessage({
        message: 'Título, ISBN, idVetor e conteúdo HTML são obrigatórios.',
        type: 'error',
      })
      return
    }

    if (previewingHtml || !htmlPreviewValid) {
      changeMessage({
        message: 'Aguarde a pré-visualização do CMS antes de salvar o capítulo.',
        type: 'error',
      })
      return
    }

    if (
      existingContent &&
      !window.confirm(
        'Este capítulo já existe no CMS. Deseja substituir o conteúdo existente pelo HTML revisado?',
      )
    ) {
      return
    }

    this.setState({ saving: true })

    const chapterData = {
      ...(chapter || {}),
      ...content,
    }

    saveBookChapterInCms(
      chapterData,
      {
        isbn: content.isbn,
        titulo: bookName || content.tituloLivro,
        book_name: bookName || content.tituloLivro,
      },
      chapterIndex,
      (existingContent || {})._id || (existingContent || {}).id || null,
    )
      .then((result) => {
        this.setState({ saving: false })
        changeMessage({
          message: result.replaced
            ? 'Capítulo substituído no CMS com sucesso.'
            : 'Capítulo cadastrado no CMS com sucesso.',
        })
        if (onSaved) {
          onSaved({
            ...result,
            repeatedFields: this.getRepeatedContentFields(),
          })
        } else {
          onClose()
        }
      })
      .catch((err) => {
        this.setState({ saving: false })
        const response = (err || {}).response || {}
        const responseData = response.data || {}

        if (response.status === 409 && responseData.existing) {
          if (responseData.existing.codigo) {
            this.handleChangeField('codigo', responseData.existing.codigo)
          }
          if (onConflict) onConflict(responseData.existing)
        }

        const errorMsg = getApiErrorMessage(err, 'Erro ao cadastrar capítulo.')
        changeMessage({ message: errorMsg, type: 'error' })
      })
  }

  render() {
    const {
      open,
      onClose,
      fullScreen,
      classes,
      chapter,
      existingContent,
      bookIsbn,
      bookName,
    } = this.props
    const {
      content,
      editorOpen,
      htmlPreview,
      htmlPreviewError,
      htmlPreviewValid,
      previewingHtml,
      saving,
    } = this.state
    const chapterTitle = (chapter || {}).titulo || (chapter || {}).capitulo || 'Capítulo'

    return (
      <Fragment>
        <Dialog
          modalId="vetorizacao-livros-revisao-capitulo"
          modalParams={{ isbn: bookIsbn, idVetor: content.idVetor }}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="md"
          open={open}
          onClose={!saving ? onClose : undefined}
        >
          <DialogTitle id="vetorizacao-livros-revisao-capitulo-title">
            Vetorização de livros — Revisão do capítulo: {chapterTitle}
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            {saving && (
              <div className={classes.loadingOverlay}>
                <CircularProgress size={50} />
                <Typography variant="subtitle1" style={{ marginTop: 16 }}>
                  Salvando conteúdo...
                </Typography>
              </div>
            )}

            <div style={{ opacity: saving ? 0.3 : 1 }}>
              {existingContent ? (
                <div className={classes.existingWarning}>
                  <Typography variant="body2">
                    Este capítulo já está cadastrado no CMS. Ao salvar, você poderá confirmar a
                    substituição do registro existente.
                  </Typography>
                </div>
              ) : null}
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel shrink htmlFor="field-idVetor">
                  ID Vetor
                </InputLabel>
                <Input disabled fullWidth value={content.idVetor || ''} id="field-idVetor" />
              </FormControl>

              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-titulo">Título *</InputLabel>
                <Input
                  fullWidth
                  required
                  type="text"
                  onChange={(e) => this.handleChangeField('titulo', e.target.value)}
                  value={content.titulo || ''}
                  id="field-titulo"
                />
              </FormControl>

              <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 12 }}>
                Livro: {content.tituloLivro || bookName} · ISBN: {content.isbn || bookIsbn}. Os
                metadados do livro vieram do pré-cadastro e não precisam ser preenchidos novamente.
              </Typography>

              <div className={classes.formControl}>
                <TextField
                  fullWidth
                  onChange={(obj) => this.handleChangeField('autores', obj)}
                  value={formatContentSelectValue(content.autores || [])}
                  placeholder="Selecione..."
                  name="react-select-chip-autores"
                  label="Autores"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputComponent: SelectWrapped,
                    inputProps: {
                      multi: true,
                      filterOptions: filterOptionsFunction,
                      instanceId: 'react-select-chip-label',
                      id: 'react-select-chip-autores',
                      loadOptions: API.authors.getSelectAuthors,
                    },
                  }}
                />
              </div>

              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-codigo">Código</InputLabel>
                <Input
                  fullWidth
                  type="text"
                  inputComponent={CodigoCapituloField}
                  onChange={(e) => this.handleChangeField('codigo', e.target.value)}
                  value={content.codigo || ''}
                  id="field-codigo"
                />
              </FormControl>

              <div className={classes.formControl}>
                <TextField
                  fullWidth
                  onChange={(obj) => this.handleChangeField('especialidades', obj)}
                  value={formatContentSelectValue(content.especialidades || [])}
                  placeholder="Selecione..."
                  name="react-select-chip-especialidades"
                  label="Especialidades"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputComponent: SelectWrapped,
                    inputProps: {
                      multi: true,
                      filterOptions: filterOptionsFunction,
                      instanceId: 'react-select-chip-label',
                      id: 'react-select-chip-especialidades',
                      loadOptions: API.specialities.getSelectSpecialities,
                    },
                  }}
                />
              </div>

              <div className={classes.formControl}>
                <TextField
                  fullWidth
                  onChange={(obj) => this.handleChangeField('palavrasChave', obj)}
                  value={formatContentSelectValue(content.palavrasChave || [])}
                  placeholder="Selecione..."
                  name="react-select-chip-keywords"
                  label="Palavras-chave"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputComponent: SelectWrapped,
                    inputProps: {
                      multi: true,
                      filterOptions: filterOptionsFunction,
                      instanceId: 'react-select-chip-label',
                      id: 'react-select-chip-keywords',
                      loadOptions: API.keywords.getSelectKeywords,
                    },
                  }}
                />
              </div>

              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
                <Input
                  fullWidth
                  type="number"
                  onChange={(e) => this.handleChangeField('pesoDA', e.target.value)}
                  value={content.pesoDA || ''}
                  id="field-pesoDA"
                />
              </FormControl>

              <FormControl className={classes.formControl} fullWidth>
                <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
                <Input
                  fullWidth
                  type="text"
                  onChange={(e) => this.handleChangeField('idioma', e.target.value)}
                  value={content.idioma || ''}
                  id="field-idioma"
                />
              </FormControl>

              <fieldset style={{ marginTop: '16px' }}>
                <legend>Seção</legend>

                <FormControl className={classes.formControl} fullWidth>
                  <InputLabel htmlFor="field-tituloSecao">Título seção</InputLabel>
                  <Input
                    fullWidth
                    type="text"
                    onChange={(e) => this.handleChangeField('tituloSecao', e.target.value)}
                    value={content.tituloSecao || ''}
                    id="field-tituloSecao"
                  />
                </FormControl>

                <div className={classes.formControl}>
                  <TextField
                    fullWidth
                    onChange={(obj) => this.handleChangeField('autoresSecao', obj)}
                    value={formatContentSelectValue(content.autoresSecao || [])}
                    placeholder="Selecione..."
                    name="react-select-chip-autoresSecao"
                    label="Autores seção"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      inputComponent: SelectWrapped,
                      inputProps: {
                        multi: true,
                        filterOptions: filterOptionsFunction,
                        instanceId: 'react-select-chip-label',
                        id: 'react-select-chip-autoresSecao',
                        loadOptions: API.authors.getSelectAuthors,
                      },
                    }}
                  />
                </div>

              </fieldset>

              {/* ====== PREVIEW DO HTML E BOTÃO EDITAR ====== */}
              <div style={{ marginTop: 20 }}>
                <div className={classes.htmlPreviewLabel}>
                  <Typography variant="subtitle1">Pré-visualização do HTML no CMS:</Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={this.handleOpenEditor}
                    disabled={previewingHtml}
                  >
                    <EditIcon style={{ fontSize: 16, marginRight: 5 }} />
                    Editar Conteúdo HTML
                  </Button>
                </div>

                {previewingHtml ? (
                  <div className={classes.statusLoading}>
                    <CircularProgress size={24} />
                    <Typography variant="body2">Aplicando a estrutura do CMS...</Typography>
                  </div>
                ) : null}

                {htmlPreviewError ? (
                  <div className={classes.existingWarning}>
                    <Typography variant="body2" color="error">
                      {htmlPreviewError} Edite o HTML e tente novamente.
                    </Typography>
                  </div>
                ) : null}

                <div className={'ContentPreview ContentPreview-min-600 ContentPreview-hide-unknown-markers InformedContentStyle ' + classes.htmlPreview}>
                  <ContentHtml content={content} contentPreview={htmlPreview} />
                </div>
              </div>

              <FormControl className={classes.sectionAboutControl} fullWidth>
                <InputLabel htmlFor="field-textoSecao">Sobre a seção</InputLabel>
                <Input
                  fullWidth
                  multiline
                  rows={4}
                  rowsMax={4}
                  type="text"
                  onChange={(e) => this.handleChangeField('textoSecao', e.target.value)}
                  value={content.textoSecao || ''}
                  id="field-textoSecao"
                  inputProps={{
                    className: classes.sectionAboutTextarea,
                  }}
                />
              </FormControl>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose} color="default" disabled={saving}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSave}
              disabled={saving || previewingHtml || !htmlPreviewValid}
            >
              {saving
                ? 'Salvando...'
                : existingContent
                  ? 'Substituir e ir para o próximo'
                  : 'Cadastrar e ir para o próximo'}
            </Button>
          </DialogActions>
        </Dialog>

        <LocalHtmlEditorModal
          modalId="vetorizacao-livros-editor-html-capitulo"
          modalTitle={'Vetorização de livros — Editor HTML do capítulo: ' + chapterTitle}
          modalParams={{ isbn: bookIsbn, idVetor: content.idVetor }}
          open={editorOpen}
          onClose={this.handleCloseEditor}
          onApply={this.handleApplyHtml}
          initialContent={content.conteudoHtml || ''}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
})

const mapDispatchToProps = (dispatch) => ({
  changeMessage: ({ message, type }) => {
    dispatch(messageActions.changeMessage({ message, type }))
  },
  saveBookChapterInCms: (chapter, bookData, index, existingContentId) =>
    dispatch(
      bookVectorizationActions.saveBookChapterInCms(
        chapter,
        bookData,
        index,
        existingContentId,
      ),
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog()(withStyles(styles)(ChapterFormModal)))



// WEBPACK FOOTER //
// ./src/containers/BookVectorization/ProcessingModal/ChapterFormModal.js